<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ {{ 'Repair Code Exclusion' }}</span>
</div>

<form [formGroup]="filterFormGroup" class="list-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Repair code exclusion</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-repair-code-exclusion-search
        class="search-bar"
        [searchTextForm]="filterFormGroup.controls.searchTextForm"></app-repair-code-exclusion-search>
    </div>
  </div>
  <app-repair-code-exclusion-filters [filterFormGroup]="filterFormGroup"></app-repair-code-exclusion-filters>
  <app-repair-code-exclusion-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-repair-code-exclusion-grid>
</form>
